import TransferInstruction from "manifest-components/src/classes/transferInstruction";
import TransferDestination from "manifest-components/src/classes/transferDestination";
import { ProviderMailingDetails } from "manifest-components/src/api/APITransferInstruction";

export enum Actions {
  FETCHING_CURRENT_TRANSFER_INSTRUCTION = "FETCHING_CURRENT_TRANSFER_INSTRUCTION",
  FETCHING_PROVIDER_MAILING_DETAILS = "FETCHING_PROVIDER_MAILING_DETAILS",
  FETCHING_ROTH_TRANSFERRED_DESTINATIONS = "FETCHING_ROTH_TRANSFERRED_DESTINATIONS",
  GET_PROVIDER_MAILING_DETAILS = "GET_PROVIDER_MAILING_DETAILS",
  GET_ROTH_TRANSFERRED_DESTINATIONS = "GET_ROTH_TRANSFERRED_DESTINATIONS",
  CONNECT_DESTINATION_TO_TRANSFER = "CONNECT_DESTINATION_TO_TRANSFER",
  MAIL_CONFIRMED = "MAIL_CONFIRMED",
  SET_CURRENT_TRANSFER_INSTRUCTION = "SET_CURRENT_TRANSFER_INSTRUCTION",
}

export type Action =
  | { type: Actions.FETCHING_CURRENT_TRANSFER_INSTRUCTION }
  | { type: Actions.FETCHING_PROVIDER_MAILING_DETAILS }
  | { type: Actions.FETCHING_ROTH_TRANSFERRED_DESTINATIONS }
  | {
      type: Actions.GET_PROVIDER_MAILING_DETAILS;
      payload: ProviderMailingDetails;
    }
  | {
      type: Actions.GET_ROTH_TRANSFERRED_DESTINATIONS;
      payload: TransferDestination[];
    }
  | { type: Actions.CONNECT_DESTINATION_TO_TRANSFER }
  | { type: Actions.MAIL_CONFIRMED }
  | {
      type: Actions.SET_CURRENT_TRANSFER_INSTRUCTION;
      payload: { transferIdReceived?: number; data: TransferInstruction };
    };
